/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/coreUsageOperationsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a CoreUsageOperations. */
var CoreUsageOperations = /** @class */function () {
  /**
   * Create a CoreUsageOperations.
   * @param {LabsApiClientContext} client Reference to the service client.
   */
  function CoreUsageOperations(client) {
    this.client = client;
  }
  CoreUsageOperations.prototype.get = function (options, callback) {
    return this.client.sendOperationRequest({
      options: options
    }, getOperationSpec, callback);
  };
  return CoreUsageOperations;
}();
export { CoreUsageOperations };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getOperationSpec = {
  httpMethod: "GET",
  path: "api/subscriptions/{subscriptionId}/coreUsage",
  urlParameters: [Parameters.subscriptionId],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.CoreUsage
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};